export default {
  education: [
    {id: 'lowerSecondary', value:'Неповна середня'},
    {id: 'secondary', value:'Середня'},
    {id: 'secondarySpecial', value:'Середня спеціальна'},
    {id: 'lowerHigher', value:'Незакінчена вища'},
    {id: 'higher', value:'Вища'},
    {id: 'secondHigher', value:'Друга вища'},
    {id: 'mba', value:'Вчений ступінь/MBA'},
    {id: 'lowerSecondary', value:'Неповна середня'},
    {id: 'secondary', value:'Середня'},
    {id: 'secondarySpecial', value:'Середня спеціальна'},
    {id: 'lowerHigher', value:'Незакінчена вища'},
    {id: 'higher', value:'Вища'},
    {id: 'secondHigher', value:'Друга вища'},
    {id: 'mba', value:'Вчений ступінь/MBA'},
    {id: 'lowerSecondary', value:'Неповна середня'},
    {id: 'secondary', value:'Середня'},
    {id: 'secondarySpecial', value:'Середня спеціальна'},
    {id: 'lowerHigher', value:'Незакінчена вища'},
    {id: 'higher', value:'Вища'},
    {id: 'secondHigher', value:'Друга вища'},
    {id: 'mba', value:'Вчений ступінь/MBA'},
  ],
  familyStatus: [
    {id: 'notMarried', value:'Неодружений/Незаміжня'},
    {id: 'married', value:'Одружений/Заміжня'},
    {id: 'civilMarriage', value:'Цивільний шлюб'},
    {id: 'dicorced', value:'Розлучений (на)'},
    {id: 'widower', value:'Вдівець'},
  ],
  city: [
    {id: 'Dnipro', value:'Дніпропетровська область'},
    {id: 'Donetsk', value:'Донецька область'},
    {id: 'Zaporizhua', value:'Запорізька область'},
    {id: 'Zakarpatya', value:'Закарпатська'},
  ],
  position: [
    {id: 'operative', value: 'Кваліфікований робітник'},
    {id: 'specialist', value: 'Спеціаліст, але не керівник'},
    {id: 'notQualifiedManager', value: 'Не кваліфікований керівник'},
    {id: 'official', value: 'Службовець'},
    {id: 'seniorManager', value: 'Керівник вищої ланки'},
    {id: 'lowManager', value: 'Керівник нижчої ланки'},
    {id: 'middleManager', value: 'Керівник середньої ланки'},
  ],
  typeBusyness: [
    {id: 'employee', value: 'Найманий працівник'},
    {id: 'privateEntrepreneur', value: 'Приватний підприємець'},
    {id: 'notary', value: 'Нотаріус'},
    {id: 'pensioner', value: 'Пенсіонер'},
    {id: 'student', value: 'Студент'},
    {id: 'unemployed', value: 'Безробітний'},
  ]
}